import { useEffect, useState } from 'react';
import { collection, onSnapshot, orderBy, query } from 'firebase/firestore';
import db from '../firebase/firestore';

/**
 * Galerie live aus Firestore. Sortiert nach `order` (vom Admin gesetzt),
 * damit die Reihenfolge kuratierbar bleibt und nicht am Upload-Zeitpunkt hängt.
 */
export function useGallery({ limitTo = null } = {}) {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    // Siehe useEvents: ohne Konfiguration Leerzustand statt Absturz.
    if (!db) {
      setLoading(false);
      return undefined;
    }

    const q = query(collection(db, 'gallery'), orderBy('order', 'asc'));

    const unsubscribe = onSnapshot(
      q,
      (snap) => {
        setItems(snap.docs.map((d) => ({ id: d.id, ...d.data() })));
        setLoading(false);
        setError(null);
      },
      (err) => {
        setError(err);
        setLoading(false);
      }
    );

    return unsubscribe;
  }, []);

  const visible = limitTo ? items.slice(0, limitTo) : items;

  return { items: visible, total: items.length, loading, error };
}
